<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-lg-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex custom-nav-bar1">
      <b-link :to="{ name: 'UserMyOrders' }">
        <img :src="$i18n.locale === 'en' ? '//soustitreur.com/images/logo/logo-closedCaptioner.svg' : '//soustitreur.com/images/logo/logo.png'" style="height:40px;">
      </b-link>
      <div
        v-if="!isNavMenuHidden"
        class="header-navbar navbar-expand-sm navbar navbar-horizontal navbar-light menu-border d-none d-lg-block"
      >
        <horizontal-nav-menu />
      </div>
    </div>

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import Locale from './Locale.vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import UserDropdown from './UserDropdown.vue'
import HorizontalNavMenu from '@/components/header/horizontal-nav-menu/HorizontalNavMenu.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import useLayoutHorizontal from '@/components/layouts/useLayoutHorizontal'
import useVerticalLayout from '@core/layouts/layout-vertical/useVerticalLayout'
import { onUnmounted } from '@vue/composition-api'
import { useScrollListener } from '@core/comp-functions/misc/event-listeners'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Locale,
    DarkToggler,
    UserDropdown,
    HorizontalNavMenu,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    const {
      skin,
      navbarType,
      footerType,
      routerTransition,
      isNavMenuHidden,
    } = useAppConfig()

    // Vertical Menu
    const {
      isVerticalMenuActive, overlayClasses, resizeHandler,
    } = useVerticalLayout(navbarType, footerType)

    // Resize handler
    resizeHandler()
    window.addEventListener('resize', resizeHandler)
    onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler)
    })

    const {
      navbarMenuTypeClass,
      layoutClasses,
      footerTypeClass,
    } = useLayoutHorizontal(navbarType, footerType, isVerticalMenuActive)

    // Scroll Listener
    const { scrolledTo } = useScrollListener()

    return {
      // skin
      skin,

      // Layout
      layoutClasses,

      // Navbar
      navbarType,
      navbarMenuTypeClass,

      // Menu Hidden
      isNavMenuHidden,

      // Router Transition
      routerTransition,

      // Footer
      footerTypeClass,

      // Scroll Listeners
      scrolledTo,

      // Vertical Menu
      isVerticalMenuActive,
      overlayClasses,
    }
  },
}
</script>
<style>
[dir] .horizontal-menu .header-navbar.navbar-horizontal ul#main-menu-navigation>li>a {
    padding: 0.715rem 1.25rem;
}
[dir] .horizontal-menu .custom-nav-bar1 .navbar.header-navbar .navbar-container {
    padding-top: 0rem;
    padding-right: 2rem;
    padding-bottom: 0rem;
    padding-left: 2rem;
}
</style>